import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { MessageSquare, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { useState } from "react";

export function MarketingNav() {
  const [open, setOpen] = useState(false);

  const navigationItems = [
    { title: "Solutions", path: "/solutions" },
    { title: "How it Works", path: "/how-it-works" },
    { title: "Pricing", path: "/pricing" },
    //{ title: "About", path: "/about" },
    { title: "Support", path: "/support" },
  ];

  return (
    <nav className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2">
              <MessageSquare className="h-6 w-6" />
              <span className="font-bold text-xl">MeetMemoize</span>
            </Link>
            
            <div className="hidden md:flex items-center gap-6">
              {navigationItems.map((item) => (
                <Link
                  key={item.title}
                  to={item.path}
                  className="text-sm font-medium hover:text-primary"
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-4">
            <Button asChild variant="ghost">
              <Link to="/sign-in">Sign In</Link>
            </Button>
            <Button asChild>
              <Link to="/sign-up">Get Started</Link>
            </Button>
          </div>

          {/* Mobile Navigation */}
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden">
                <Menu className="h-5 w-5" />
                <span className="sr-only">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] sm:w-[350px] p-0">
              <div className="flex flex-col h-full">
                <div className="flex-1 overflow-auto py-6 px-4">
                  <nav className="space-y-2">
                    {navigationItems.map((item) => (
                      <Link
                        key={item.title}
                        to={item.path}
                        onClick={() => setOpen(false)}
                        className="block px-4 py-2 text-sm hover:bg-accent rounded-lg"
                      >
                        {item.title}
                      </Link>
                    ))}
                  </nav>
                </div>

                <div className="border-t p-4">
                  <div className="space-y-3">
                    <Button
                      asChild
                      variant="ghost"
                      className="w-full justify-start"
                    >
                      <Link to="/sign-in" onClick={() => setOpen(false)}>
                        Sign In
                      </Link>
                    </Button>
                    <Button
                      asChild
                      className="w-full justify-start"
                    >
                      <Link to="/sign-up" onClick={() => setOpen(false)}>
                        Get Started
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}